module.exports = __webpack_public_path__ + "img/adopt-egg-bg.144dcfee.svg";